import { trackEvent } from '~/utils/dataLayer';

export const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
  e.stopPropagation();
  const target = e.target as HTMLElement;
  const inlineHtmlWrapperDiv = e.currentTarget;
  if (!inlineHtmlWrapperDiv.contains(target)) {
    return;
  }

  // If clickout offer link -----------------------------
  if (
    target.tagName === 'A' &&
    target.classList.contains('button-link') &&
    (target as HTMLAnchorElement).target === '_blank'
  ) {
    const link = target as HTMLAnchorElement;
    const clickoutURL = link.href;

    trackEvent('claimOffer', {
      eventCategory: 'Offers',
      eventAction: 'new_customers_offer',
      eventLabel: 'hypertext_link',
      offer: {
        name: '',
        customer: '',
        bookie: '',
        type: '',
        clickoutURL,
      },
    });
  }
};
